import Rails from 'rails-ujs';
Rails.start();

import './purchases'
import './credit_cards'
import './contact'
import './sample_pages_modal'
